import { Component, computed, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

import { ChrComponentsModule } from '@ciphr-design-system/angular';

import { CollectionFilterDirective } from '../collection-filter.directive';
import { CollectionFilterHeaderComponent } from '../collection-filter-header.component';

@Component({
  selector: 'ciphr-date-collection-filter',
  standalone: true,
  imports: [ChrComponentsModule, CollectionFilterHeaderComponent],
  providers: [DatePipe],
  templateUrl: './date-collection-filter.component.html',
  styleUrl: './date-collection-filter.component.scss',
})
export class DateCollectionFilterComponent {
  private readonly collectionFilterDirective = inject(CollectionFilterDirective);
  private readonly datePipe = inject(DatePipe);

  readonly expanded = this.collectionFilterDirective.expanded;
  readonly filter = this.collectionFilterDirective.filter;
  readonly selectedValue = computed(() => {
    const [value] = this.collectionFilterDirective.selectedValues();
    return value as string;
  });

  setValueSelection({ target }: Event): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const date = this.datePipe.transform((target as any).date as Date | null, 'yyyy-MM-dd');
    this.collectionFilterDirective.setValuesSelection(date ? [date] : []);
  }
}
